import { motion } from "framer-motion";
import { Target, Compass, CheckCircle2 } from "lucide-react";

const MISSION = [
  "Quality Education",
  "Practical Learning",
  "Skill Development",
  "Career Guidance",
  "Global Education Support",
  "Placement Assistance",
];

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="section relative">
      <div className="container-x grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        <div className="lg:col-span-6">
          <div className="relative">
            <div className="absolute -top-6 -left-6 h-24 w-24 rounded-3xl bg-[#0A3161]/10 blur-2xl" />
            <div className="absolute -bottom-6 -right-6 h-24 w-24 rounded-3xl bg-[#B31942]/10 blur-2xl" />
            <img
              src="https://images.unsplash.com/photo-1741699427799-3fbb70fce948?auto=format&fit=crop&w=1200&q=80"
              alt="Students studying together in a university library"
              className="relative rounded-3xl object-cover w-full h-[420px] md:h-[520px] border border-black/5 soft-shadow"
            />
            <div className="absolute left-6 bottom-6 glass rounded-2xl px-4 py-3 soft-shadow-lg">
              <div className="text-[11px] uppercase tracking-widest text-slate-500">Since 2016</div>
              <div className="text-sm font-semibold text-slate-900">Delivering global-quality education</div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-6">
          <motion.div
            initial={{ opacity: 0, y: 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="inline-flex items-center gap-2 rounded-full border border-[#B31942]/20 bg-[#B31942]/5 px-3 py-1 text-[12px] font-semibold text-[#B31942]"
          >
            About IIUTCStudy
          </motion.div>
          <h2 className="mt-4 font-display font-extrabold text-4xl md:text-5xl tracking-tight text-slate-900" data-testid="about-heading">
            One institute. Every path from <span className="text-[#0A3161]">upskill</span> to <span className="text-[#B31942]">abroad</span>.
          </h2>
          <p className="mt-5 text-slate-600 text-lg leading-relaxed">
            IIUTCStudy — International Institute of Unified Tech & Commerce — is a
            career-first learning company delivering technology training, business
            education, industry certifications, internships, placement support and
            end-to-end study abroad consulting under a single roof.
          </p>

          <div className="mt-8 grid sm:grid-cols-2 gap-5">
            <div className="rounded-2xl border border-black/5 bg-white p-5 soft-shadow" data-testid="vision-card">
              <div className="inline-flex items-center gap-2 text-[#0A3161] font-semibold">
                <Compass className="h-5 w-5" /> Our Vision
              </div>
              <p className="mt-2 text-sm text-slate-600 leading-relaxed">
                To become a globally recognized institute delivering world-class
                education, innovation and career development.
              </p>
            </div>
            <div className="rounded-2xl border border-black/5 bg-white p-5 soft-shadow" data-testid="mission-card">
              <div className="inline-flex items-center gap-2 text-[#B31942] font-semibold">
                <Target className="h-5 w-5" /> Our Mission
              </div>
              <ul className="mt-2 grid grid-cols-1 gap-1.5">
                {MISSION.map((m) => (
                  <li key={m} className="text-sm text-slate-700 inline-flex items-center gap-2">
                    <CheckCircle2 className="h-3.5 w-3.5 text-[#0A3161]" /> {m}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
